import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Данные успешно сохранены", -1)
const _hoisted_2 = { class: "mb-4 d-flex flex-row justify-content-start align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Добавить клиенра ")
const _hoisted_4 = {
  key: 0,
  class: "ms-5 pt-2"
}
const _hoisted_5 = { class: "border rounded bg-white px-3 py-3 mb-5" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center py-5 my-5"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("ID")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Имя, фамилия")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Уволен")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Список клиенров пуст ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_CAlert = _resolveComponent("CAlert")!
  const _component_CButton = _resolveComponent("CButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CFormSwitch = _resolveComponent("CFormSwitch")!
  const _component_CSpinner = _resolveComponent("CSpinner")!
  const _component_CTableHeaderCell = _resolveComponent("CTableHeaderCell")!
  const _component_CTableRow = _resolveComponent("CTableRow")!
  const _component_CTableHead = _resolveComponent("CTableHead")!
  const _component_CTableDataCell = _resolveComponent("CTableDataCell")!
  const _component_CTableBody = _resolveComponent("CTableBody")!
  const _component_CTable = _resolveComponent("CTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.successSave)
      ? (_openBlock(), _createBlock(_component_CAlert, {
          key: 0,
          color: "success",
          class: "d-flex align-items-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CIcon, {
              icon: "cil-check-circle",
              class: "flex-shrink-0 me-2",
              width: "24",
              height: "24"
            }),
            _hoisted_1
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        custom: "",
        to: "/cleaners/add",
        class: "sidebar-header__balance"
      }, {
        default: _withCtx(({ navigate }) => [
          (!_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_CButton, {
                key: 0,
                color: "primary",
                onClick: navigate
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CIcon, { icon: "cil-plus" }),
                  _hoisted_3
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (!_ctx.isLoading && _ctx.cleaners.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_CFormSwitch, {
              label: "Отображать уволенных",
              id: "showIsFiredSwitch",
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFired = $event.target.checked)),
              checked: _ctx.showFired,
              size: "lg"
            }, null, 8, ["checked"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_CSpinner, { color: "primary" })
          ]))
        : (_openBlock(), _createBlock(_component_CTable, {
            key: 1,
            striped: "",
            hover: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CTableHead, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CTableRow, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CTableHeaderCell, { scope: "col" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_CTableBody, null, {
                default: _withCtx(() => [
                  (_ctx.cleanersForList.length === 0)
                    ? (_openBlock(), _createBlock(_component_CTableRow, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CTableHeaderCell, {
                            scope: "row",
                            colspan: "6",
                            class: "text-center"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.cleanersForList, (cleaner) => {
                        return (_openBlock(), _createBlock(_component_CTableRow, {
                          key: cleaner,
                          align: "middle"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(cleaner.id), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_CTableDataCell, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(cleaner.firstName) + " " + _toDisplayString(cleaner.lastName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_CTableDataCell, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(cleaner.isFired ? 'Да' : 'Нет'), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_CTableDataCell, { class: "text-end" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                  custom: "",
                                  to: `/cleaners/edit/${cleaner.id}`
                                }, {
                                  default: _withCtx(({ navigate }) => [
                                    _createVNode(_component_CButton, {
                                      color: "success",
                                      onClick: navigate
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CIcon, { icon: "cil-pencil" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ])
  ], 64))
}